import { SIGN_IN, SIGN_OUT, ADD_PROFILE } from '../constants';

const INITIAL_STATE = {
  signedIn: null,
  profile: null,
  userProfile: null
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SIGN_IN:
      return { ...state, signedIn: true, profile: payload };
    case SIGN_OUT:
      return { ...state, signedIn: false, profile: null };
    case ADD_PROFILE:
      return { ...state, userProfile: payload };
    default:
      return state;
  }
};
